import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  IconButton,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import {
  getBlobsInContainer,
  createBlobInContainer, deleteBlobIfItExists,
} from "src/utils/azureBlob";
// ----------------------------------------------------------------------

export default function ImageLibraryPage() {
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      await getContainerImages();
    };

    fetchImages().catch(console.error);
  }, []);
  const getContainerImages = async () => {
    const data = await getBlobsInContainer();
    console.log("data", data);
    setImages(data);
  };
  const deleteImageHandler = async (value)=>{
    await deleteBlobIfItExists(value)
    window.location.reload(false);

  }
  const uploadFiles = async (event) => {
    if (event.target.files.length > 0) {
      setLoading(true);
      const files = event.target.files;
      try {
        let uploadPromises = [];
        for (let i = 0; i < files.length; i++) {
          uploadPromises.push(createBlobInContainer(files[i]));
        }
        await Promise.all(uploadPromises);
        await getContainerImages();
      } catch (error) {
        console.error('Upload failed:', error);
      } finally {
        setLoading(false);
      }
    }
  };
  return (
    <>
      <Helmet>
        <title> Image Library </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Image Library
          </Typography>
          <Button
            variant="contained"
            component="label"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            Upload Files
            <input
              hidden
              accept="image/*"
              multiple
              type="file"
              onChange={uploadFiles}
            />
          </Button>
        </Stack>

        <Card sx={{ p: 2 }}>
          {images === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <ImageList cols={4} rowHeight={164}>
              {images.map((item, index) => (
                <ImageListItem key={index}>
                  <img
                    src={item.blobUrl}
                    srcSet={item.blobUrl}
                    alt="library"
                    loading="lazy"
                  />
                  <ImageListItemBar
                    title={item.blobName}
                    subtitle={""}
                    actionIcon={
                      <IconButton
                        sx={{ color: "rgba(255, 255, 255, 0.54)" }}
                        aria-label={`info about ${item.title}`}
                        value={item.blobName}
                        onClick={()=>{deleteImageHandler(item.blobName)}}
                      >
                        <Iconify icon="eva:trash-2-outline" />
                      </IconButton>
                    }
                  />
                </ImageListItem>
              ))}
            </ImageList>
          )}
        </Card>
      </Container>
    </>
  );
}
